<app-form-reqbsk
    [requestList]="requestList"
    [basketList]="basketList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()">
</app-form-reqbsk>